export class FingerprintPaymentDetails {

}

export class WebPaymentDetails {
    result: string;
    constructor(result: string) {
        this.result = result;
    } 
}

export class RedirectPaymentDetails {
    result: string;
    constructor(result: string) {
        this.result = result;
    } 
}

export class ThreeDSPaymentDetails {
    result: string;
    constructor(result: string) {
        this.result = result;
    } 
}

export class GenericDetails {
    result: Record<string,any>;
    constructor(result: Record<string,any>) {
        this.result = result;
    }
}

/**
 * The information sent to Adyen when the user completes the second step (e.g., 3D Secure authentication) and returns to the application.
 */
export type PaymentDetails = WebPaymentDetails | RedirectPaymentDetails | ThreeDSPaymentDetails | FingerprintPaymentDetails | GenericDetails;
